
/* module-registry
   ==========
   Smooths out the rough edges of Angular's dependency-injection scheme when using modular development (webpack, etc) */
let rootModule;
let queuedModules = [];

/* Pass a module name and get back an Angular module object.
   Will create a module and register it if it doesn't exist */
export function getModule(name, register=true) {
  try {
    return angular.module(name);
  } catch(e) {
    let module = angular.module(name, []);
    if(register) {
      registerModule(module);
    }
    return module;
  }
}

/* Registers a module with the root module, or queues it
   if the root module hasn't been loaded */
export function registerModule(module) {
  if (!rootModule) {
    queuedModules.push(module.name);
  } else {
    rootModule.requires.push(module.name);
  }
  return module;
}

/* Creates the root module for your application, can only be called once. */
export function createRootModule(name) {
  if(rootModule) { throw new Error(`The root module (${rootModule.name}) has already been defined!`) }
  let module = getModule(name, false);
  let requires = module.requires;
  rootModule = module;
  requires.push.apply(requires, queuedModules);
  return module;
}



/** WEBPACK FOOTER **
 ** ./utils/module-registry.js
 **/